module.exports = __webpack_public_path__ + "img/last-burstio-export.7cd9c47e.7cd9c47e.gif";